<template>
  <div>
    <div :class="`table ${loading ? 'loading' : ''}`">
      <div v-if="loading" class="loading">
        <Loader :loading="loading" />
      </div>
      <div class="table-wrrapper">
        <table>
          <thead>
            <tr>
              <th
                v-for="(item, idx) in cols"
                :key="`col-${item.column}-${idx}`"
              >
                <div class="table-header">
                  <span class="label">{{
                    item.isVisible ? item.label : ""
                  }}</span>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(row, rIdx) in rows" :key="rIdx">
              <td
                v-for="(col, idx) in cols"
                :key="`col-${row[col.column]}-${idx}`"
                :style="`width: ${col.width}px;`"
              >
                <slot
                  v-if="col.column == 'action'"
                  name="action"
                  :actions="row"
                ></slot>
                <slot
                  v-else-if="col.column == 'service'"
                  name="service"
                  :services="row"
                ></slot>
                <slot
                  v-else-if="col.column == 'price'"
                  name="price"
                  :services="row"
                  ><span>{{ row.price }}</span></slot
                >
                <slot
                  v-else-if="col.column == 'quantity'"
                  name="quantity"
                  :quantity="row"
                ></slot>
                <slot
                  v-else-if="col.column == 'discount' && col.isVisible == true"
                  name="discount"
                  :discount="row"
                ></slot>
                <slot
                  v-else-if="col.column == 'discountPercentage'"
                  name="discountPercentage"
                  :discountPercentage="row"
                ></slot>
                <span v-else style="border: none;">{{
                  col.column == "serial" ? rIdx + 1 : row[col.column]
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader";

export default {
  components: {
    Loader
  },
  props: {
    rows: {
      required: true,
      type: Array
    },
    cols: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    buttonTitle: {
      type: String
    }
  }
};
</script>

<style scoped>
.table {
  position: relative;
  /* min-height: 10px; */
  /* max-height: 600px; */
  background: var(--surface);
  /* overflow: auto; */
  z-index: 1;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
}

/* Fixed Headers */

th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

th[scope="row"] {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 1;
}

th[scope="row"] {
  vertical-align: top;
  color: inherit;
  background-color: inherit;
}

th:not([scope="row"]) {
  left: 0;
  z-index: 3;
  background: var(--surface-2);
}

.table.loading {
  overflow: hidden;
  height: 200px;
}

.table .loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
}

.table table {
  width: 100%;
  position: relative;
  border-collapse: collapse;
}

.table table thead,
tr {
  /* border-color: #ebebeb;
  border-bottom: 1px solid; */
}

.table tbody tr {
  border-bottom: 1px solid var(--line);
}
.table tbody tr td {
  border-top: 1px solid var(--line) !important;
}

.table table thead tr th {
  top: -1px;
}

.table .table-header {
  display: flex;
  align-items: center;
}
.table table thead tr th:first-child {
  justify-content: center;
  display: flex;
  padding-bottom: 20px;
}

.table table thead tr th .label {
  font-weight: 600;
  font-size: var(--fs-eyebrow);
  line-height: 1.4;
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: var(--muted);
}

.table table tr th {
  position: sticky;
  top: -1px;
  box-shadow: 0 1px 0 var(--line);
  z-index: 3000;
  left: 0;
  margin: 0;
  padding: 0.9rem;
  font-size: var(--fs-xs);
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  background: var(--surface-2);
}

.table table tr td {
  padding: 0.9rem;
}

.table table tr td:first-child {
  text-align: center;
}

.table table tr td span {
  font-weight: 400;
  font-size: var(--fs-body);
  line-height: 1.4;
  letter-spacing: 0;
  text-transform: capitalize;
  color: var(--text);
}
</style>
